import config from '../../config/config';

import getRequest from './base/get';

export default {
  /**
   * Fetch the charging point metadata
   * @param {any} data - The data
   */
  fetchChargingPointMetadata: (data: any): Promise<any> => {
    return getRequest(`${config.commonApiUrl}api/super-admin/v1/charging-point-metadata`, {
      ...data,
    });
  },
};
